<template>
  <img :src="`${teamImage}`" alt="team-details" class="img-fluid rounded-top" loading="lazy" />
  <div class="card-body">
    <div class="d-flex align-items-center justify-content-between">
      <h6 class="my-2 line-count-1">{{ teamTitle }}</h6>
      <svg class="text-primary" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g>
          <path d="M7.45109 2.34305L7.46396 3.36381L12.0063 3.42098L2.05684 13.3704L2.78774 14.1013L12.7371 4.15187L12.7943 8.69414L13.8151 8.707L13.736 2.4221L7.45109 2.34305Z" fill="currentColor"></path>
        </g>
        <defs>
          <rect width="16" height="16" rx="5" fill="white"></rect>
        </defs>
      </svg>
    </div>
    <p class="mb-0 text-primary">{{ teamText }}</p>
  </div>
</template>

<script>
export default {
  props: {
    teamTitle: { type: String, default: '' },
    teamImage: { type: String, default: '' },
    teamText: { type: String, default: '' }
  }
}
</script>
